import { useParams } from 'react-router-dom'
import ProjectStatusPage from '@/features/project-status/ProjectStatusPage'

export default function ProjectStatusSharedPage() {
  const { clientId = '' } = useParams<{ clientId: string }>()
  return <ProjectStatusPage clientId={clientId} readOnly isPublic />
}
